export const views = [
  { value: 'timeGridDay', label: 'Day' },
  { value: 'timeGridWeek', label: 'Week' },
  { value: 'dayGridMonth', label: 'Month' },
  { value: 'multiMonthYear', label: 'Year' },
  { value: 'listWeek', label: 'List' },
];
